/**
 * Collection export as CSV, in the shape ManaBox and Archidekt accept.
 *
 * One row per physical copy (quantity is always 1) so the location survives the
 * round trip: a grouped row would lose which bin and slot each card is in, and
 * the whole point of this collection is that every card has an address.
 *
 * Headers use ManaBox's documented names (`Card name`, `Set code`,
 * `Card number`, `Quantity`, `Foil`, `Language`, `Condition`, `Scryfall ID`)
 * with Unsorted's location appended. Archidekt's importer is column-mapped, so
 * it accepts these headers by mapping rather than by exact name.
 */
export const EXPORT_HEADERS = [
    'Card name',
    'Set code',
    'Card number',
    'Quantity',
    'Foil',
    'Condition',
    'Language',
    'Scryfall ID',
    'Container',
    'Bin',
    'Slot',
    'Address',
];
const needsQuotes = (value) => /[",\n\r]/.test(value);
export function escapeCsvCell(value) {
    const text = String(value);
    if (!needsQuotes(text))
        return text;
    return `"${text.replace(/"/g, '""')}"`;
}
export function exportRowToRecord(row) {
    return [
        row.name,
        row.setCode,
        row.collectorNumber,
        '1',
        row.foil ? 'true' : 'false',
        row.condition,
        row.lang,
        row.scryfallId ?? '',
        row.containerLabel,
        row.binLabel,
        String(row.slotNo),
        row.address,
    ];
}
export function buildExportCsv(rows) {
    const lines = [EXPORT_HEADERS.map(escapeCsvCell).join(',')];
    for (const row of rows) {
        lines.push(exportRowToRecord(row).map(escapeCsvCell).join(','));
    }
    return `${lines.join('\n')}\n`;
}
/** `nonfoil` is the only finish ManaBox reads as not-foil; everything else is foil. */
export const foilForFinish = (finish) => finish !== 'nonfoil';
/** `near_mint` → `Near Mint`: the words ManaBox and Archidekt show. */
export function displayCondition(condition) {
    return condition
        .split('_')
        .map((word) => (word.length === 0 ? word : word[0].toUpperCase() + word.slice(1)))
        .join(' ');
}
//# sourceMappingURL=export.js.map